// extracted by mini-css-extract-plugin
export default {"brandPromo":"BG-z","carousel":"CG-z"};